import { parseStringPromise } from 'xml2js';

function sanitizeDimension(dim: number | string): number {
  if (!dim) {
    return undefined;
  }
  if (typeof dim === 'string') {
    // percentage values are ignored
    if (dim.includes('%')) {
      return undefined;
    }
    // 'auto' is ignored
    if (dim.toLowerCase() === 'auto') {
      return undefined;
    }
    // actual length values are parsed to integer
    const parsed = parseInt(dim, 10);
    if (isNaN(parsed)) {
      return undefined;
    }
    return parsed;
  } else {
    return dim;
  }
}

async function readSvgDimensions(svg: string) {
  const svgObject: SvgXmlObj = await parseStringPromise(svg, {
    normalizeTags: true,
    trim: true,
  }).catch(err => {
    console.error(err);
  });

  const width = sanitizeDimension(svgObject?.svg?.$?.width) || 0;
  const height = sanitizeDimension(svgObject?.svg?.$?.height) || 0;

  return { height, width };
}

export default readSvgDimensions;
